import { ListGroup, ListGroupItem } from "reactstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUserPlus, faUsers } from "@fortawesome/free-solid-svg-icons"
import { connect } from "react-redux"
import { setCurrentPage } from "../../store/reducers/navigation"
import { Trans } from "@lingui/react"
import styles from "./AddMemberMenu.module.css"

const AddMemberMenu = (props) => {
  const handleNavigate = (page) => {
    props.setPage(page)
  }

  return (
    <div>
      {/* Profile Section */}
      <div className={styles.profileSection}>
        <div className={styles.profileIconContainer}>
          <FontAwesomeIcon
            icon={faUsers}
            className={styles.profileIcon}
          />
        </div>
        <div className={styles.groupName}>
          {props.group?.name}
        </div>
      </div>

      {/* Options List */}
      <div className={styles.menuContainer}>
        <ListGroup flush>
          <ListGroupItem
            className={styles.menuItem}
            onClick={() => handleNavigate("group-addMember")}
          >
            <span className={styles.menuLabel}>
              <Trans id="create_new_member_account" />
            </span>
            <FontAwesomeIcon icon={faUserPlus} className={styles.menuIcon} />
          </ListGroupItem>

          <ListGroupItem
            className={styles.menuItem}
            onClick={() => {
              if (!props.isConnected) {
                return
              }
              handleNavigate("group-addExistingMembers")
            }}
          >
            <span
              className={`${styles.menuLabel} ${
                !props.isConnected && styles.menuLabelDisabled
              }`}
            >
              <Trans id="add_existing_members" />
            </span>
            <FontAwesomeIcon icon={faUsers} className={styles.menuIcon} />
          </ListGroupItem>
        </ListGroup>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.user,
  group: state.group,
  isConnected: state.isConnected,
  members: state.loadedvslaMembers,
  isCreating: state.isCreatingVslaMember,
  error: state.createMemberError,
})

const mapDispatchToProps = (dispatch) => ({
  setPage: (page) => dispatch(setCurrentPage(page)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddMemberMenu)
